

(function(){
  document.querySelectorAll('.sk-track').forEach(function(t){
    var orig=Array.prototype.slice.call(t.children);
    for(var n=0;n<3;n++){orig.forEach(function(img){var c=img.cloneNode(true);c.alt='';c.setAttribute('aria-hidden','true');t.appendChild(c);});}
  });
  var sticky=document.getElementById('skbbSticky');
  var hero=document.querySelector('.skbb h1');
  var offer=document.getElementById('offer');
  var foot=document.querySelector('.skbb .sk-disclaimer');
  function upd(){
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var heroGone=hero.getBoundingClientRect().bottom<0;
    var o=offer.getBoundingClientRect(), offerIn=o.top<vh*0.85 && o.bottom>vh*0.15;
    var footIn=foot ? foot.getBoundingClientRect().top<vh : false;
    sticky.classList.toggle('sk-show', heroGone && !offerIn && !footIn);
  }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',upd);
  upd();
  var gMain=document.getElementById('gMain'), gImg=document.getElementById('gImg');
  var thumbs=document.querySelectorAll('.sk-thumbs button'), cur=0;
  function show(i){
    cur=(i+thumbs.length)%thumbs.length; var b=thumbs[cur];
    gImg.src=b.querySelector('img').src; gImg.alt=b.getAttribute('aria-label');
    gMain.classList.toggle('sk-first', cur===0);
    document.getElementById('gCount').textContent=(cur+1)+' / '+thumbs.length;
    Array.prototype.forEach.call(thumbs,function(x,j){x.setAttribute('aria-pressed', j===cur?'true':'false');});
  }
  Array.prototype.forEach.call(thumbs,function(b,i){ b.addEventListener('click',function(){show(i);}); });
  gMain.querySelector('.sk-prev').addEventListener('click',function(){show(cur-1);});
  gMain.querySelector('.sk-next').addEventListener('click',function(){show(cur+1);});
  var sx=null;
  gMain.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
  gMain.addEventListener('touchend',function(e){ if(sx===null)return; var dx=e.changedTouches[0].clientX-sx; if(Math.abs(dx)>40) show(cur+(dx<0?1:-1)); sx=null; });
  (function(){var d=new Date(),n=0;while(n<5){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n++;}
    document.getElementById('etaDate').textContent=d.toLocaleDateString('en-US',{weekday:'short',month:'long',day:'numeric'});})();
  var buy=document.getElementById('buy'), note=document.getElementById('protoNote');
  var VARIANT=(window.SKBB_VARIANT||54158467727644), CODE='BROTHB2G1', QTY={one:1,b2g1:3,b4g2:6};
  buy.addEventListener('click',function(){
    var t=document.querySelector('.skbb input[name=tier]:checked').value;
    buy.disabled=true; buy.textContent='Adding to cart...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:VARIANT,quantity:QTY[t]}]})})
    .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
    .then(function(){ window.location.href = t==='one' ? '/checkout' : '/discount/'+CODE+'?redirect=%2Fcheckout'; })
    .catch(function(){
      buy.disabled=false; buy.innerHTML='Claim my free bag &rarr;';
      note.textContent='Sorry, we could not add this to your cart. Please try again in a moment.'; note.hidden=false;
    });
  });
})();
